// SAD-154/SAD-161 established that QASP and CPARS must not drift on shared
// behaviour. Both tabs' per-area narratives are wired up identically (a
// string proposal bound straight onto a same-named form field), so both build
// their bindings off this one helper instead of repeating the same
// three-line shape per area.
export function narrativeFieldBindings(areas) {
    const bindings = {};
    for (const area of areas){
        bindings[area.destination] = {
            formField: area.formField,
            label: area.label,
            parse: (v)=>String(v)
        };
    }
    return bindings;
}
export function narrativeFormField(area, rows = 3) {
    return {
        kind: 'textarea',
        name: area.formField,
        label: area.label,
        rows
    };
}
